try {
  window.$ = window.jQuery = require('jquery')
  // require('./easing')
  require('magnific-popup')
} catch (e) {}
